/* eslint-disable react/destructuring-assignment */
import { Group } from '@mantine/core';
import DeleteConfirmPopover from '../../../../../../../components/DeleteConfirmPopover';
import { EntityServiceType } from '../../../../../../../models/core/entities.type';

type DataViewActionProps = {
  item: EntityServiceType;
  confirmActionResult(items: EntityServiceType[] | null, action: string, confirmed: boolean): void;
};

export default function ServiceFormViewActions(props: DataViewActionProps) {
  return (
    <Group>
      <DeleteConfirmPopover
        label="Excluir"
        message="Esta ação removerá o serviço."
        variant="outline"
        onConfirm={() => {
          props.confirmActionResult([props.item], 'excluir', true);
        }}
        onCancel={() => {
          props.confirmActionResult([props.item], 'excluir', false);
        }}
      />
    </Group>
  );
}
